import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import storageService, { Locals } from '../../utils/storageService';
import { CartPage } from './CartPage';
import { TableLoadingLayout } from '../layouts/LoadingLayouts/TableLoadingLayout';
import { isNullOrUndefined } from '../../utils/utils';
import useShopifyCartSWR from '../../hooks/shopify/useShopifyCartSWR';
import { ErrorTypography } from '../styled/ErrorTypography';

export const CartPageWrapper = () => {
    const { t } = useTranslation('cart', {
        keyPrefix: 'CART',
    });

    const cart_token = storageService.getItem(Locals.CART_TOKEN);
    const { cart, isLoading, isError, isValidating, forceRefresh } =
        useShopifyCartSWR(cart_token);

    return (
        <>
            {isError && <ErrorTypography errorCode={'CART_LOADING_ERROR'} />}
            {(isLoading || isValidating) && <TableLoadingLayout />}
            {!isLoading && !isValidating && isNullOrUndefined(cart) && (
                <Typography>{t('EMPTY_CART')}</Typography>
            )}
            {!isLoading && !isValidating && !isNullOrUndefined(cart) && (
                <CartPage cart={cart} refetch={forceRefresh} />
            )}
        </>
    );
};
